import { Text, TextProps, StyleProp, TextStyle } from 'react-native';
import { useTheme } from '@/theme';

export type TextVariant =
  | 'hero'
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'heading'
  | 'subheading'
  | 'title'
  | 'body'
  | 'bodyStrong'
  | 'caption'
  | 'label';

export type ThemedTextProps = TextProps & {
  variant?: TextVariant;
  color?: string;
  style?: StyleProp<TextStyle>;
};

export function ThemedText({
  variant = 'body',
  color,
  style,
  children,
  ...rest
}: ThemedTextProps) {
  const theme = useTheme();
  const typography = theme.typography[variant];
  const textColor =
    color ?? (variant === 'label' ? theme.colors.textSecondary : theme.colors.text);

  return (
    <Text
      accessibilityRole="text"
      {...rest}
      style={[
        {
          color: textColor,
          fontFamily: 'System',
        },
        typography,
        style,
      ]}
    >
      {children}
    </Text>
  );
}

export const Heading = (props: ThemedTextProps) => <ThemedText variant="h1" {...props} />;
export const SubHeading = (props: ThemedTextProps) => <ThemedText variant="h2" {...props} />;
export const Title = (props: ThemedTextProps) => <ThemedText variant="title" {...props} />;
export const Body = (props: ThemedTextProps) => <ThemedText variant="body" {...props} />;
export const Caption = (props: ThemedTextProps) => <ThemedText variant="caption" {...props} />;

